import React, { useEffect, useState } from "react";
import "../../_css/Settings.css";
import { LiaToggleOnSolid, LiaToggleOffSolid } from "react-icons/lia";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { getUserProfile, updateNotificationStatus } from "../../requests";
import { notifySuccess, notifyError } from "../../utils/helper";

const SettingsNotifyUI = () => {
  const dispatch = useDispatch();
  const [pushNotifys, setPushNotifys] = useState(true);
  const [emailNotifys, setemailNotifys] = useState(true);

  const handleUpdateNotificationStatus = async (type, status) => {
    try {
      dispatch(startLoader());
      const response = await updateNotificationStatus({ type: type, status: status });


      if(response.status < 400){
        notifySuccess(response?.data?.message || "Notification status updated successfully");
        getProfile();
      }
    } catch (error) {
      notifyError(error?.response?.data?.error || "Something went wrong");
      console.error(error);
    } finally {
      dispatch(stopLoader());
    }
  }

  const handleChange = (type) => {
    if(type == 1){
      setPushNotifys((p) => {
        handleUpdateNotificationStatus(1, p == true? 0 : 1);
        return !p;
      })
     
      
    }
    if(type == 2){
       setemailNotifys((p) => {
        handleUpdateNotificationStatus(2, p == true? 0 : 1);
        return !p;
      })
      
    }


  }

  const getProfile = async () => {
    try {
      dispatch(startLoader());
      const response = await getUserProfile();
      console.log(response?.data?.user);

      if(response.status < 400){
        if(response?.data?.user?.push_notifications == 1){
          setPushNotifys(true);
        }else{
          setPushNotifys(false);
        }

        if(response?.data?.user?.email_notifications == 1){
          setemailNotifys(true);
        }else{
          setemailNotifys(false);
        }
      }

    
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(stopLoader());
    }
  }

  useEffect(() => {
    getProfile();
  }, []);

  



  return (
    <div className="settings-notify-con">
      <div className="s-notify-left">
        <div className="s-notity-text-con">
          <div className="s-notify-text">
            <div className="s-notify-title">Notifications</div>
            <div className="s-notify-desc">Control your notifications</div>
          </div>
        </div>
      </div>
      <div className="s-notify-right">
        <div className="s-notity-text-con">
          <div className="s-notify-text">
            <div className="s-notify-title">Push notifications</div>
            <div className="s-notify-desc" >
              Enable to receive push notifications
            </div>
          </div>
          <div className="pe-cursor" style={{userSelect:'none'}}  onClick={() => (handleChange(1))}>
            
            {pushNotifys ? (
              <LiaToggleOnSolid size={40} color="#01a7de" />
            ) : (
              <LiaToggleOffSolid size={40} color="#d1d5dbc1" />
            )}{" "}
          </div>
        </div>

        <div className="s-notity-text-con">
          <div className="s-notify-text">
            <div className="s-notify-title">Email notifications</div>
            <div className="s-notify-desc" >
              Enable to receive email notifications
            </div>
          </div>
          <div className="pe-cursor" style={{userSelect:'none'}} onClick={() => handleChange(2)}>
            
            {emailNotifys ? (
              <LiaToggleOnSolid size={40} color="#01a7de" />
            ) : (
              <LiaToggleOffSolid size={40} color="#d1d5dbc1" />
            )}{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsNotifyUI;
